import { Fragment, memo, useMemo } from 'react';
import Pluralize from 'react-pluralize';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import dayjsPluginUTC from 'dayjs-plugin-utc';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import InfoBlock from '../../InfoBlock';
import PortsOfCall from '../../TravelOption/PortsOfCall';
import StateroomDetails from '../StateroomDetails';
import formatStateroomsInput from '../../../helpers/formatStateroomsInput';

dayjs.extend(dayjsPluginUTC);

const CruiseInfo = ({
  itinerary,
  // passengerCity,
  // tripConfirmation,
}) => {
  const { staterooms } = useSelector((store) => store.tripSearch.searchObj);
  const { travelAgency } = useSelector((store) => store.user);
  const { passengers } = useSelector((state) => state.trip);
  // get non empty item
  // const itineraryCabin = itinerary.cabins.find((c) => (c));
  // const hasPassengerPricing = itineraryCabin && itineraryCabin.selectedRateOption
  //   .passengerPricing != null;
  // const selectedAgeGroups = hasPassengerPricing
  //   ? _.flatMap(itinerary
  //     .cabins, (cabin) => cabin && cabin
  //     .selectedRateOption
  //     .passengerPricing
  //     .map((item) => item.ageGroup))
  //   : null;

  // let travelersCount = (selectedAgeGroups || []).length;
  // if (!hasPassengerPricing && tripConfirmation && tripConfirmation.travelers) {
  //   travelersCount = tripConfirmation.travelers.length;
  // }

  // const isMixedTypeOfPassengers = selectedAgeGroups === null
  // || new Set(selectedAgeGroups).size > 1;

  const doHaveVirtuosoBenefits = useMemo(
    () =>
      itinerary.itineraryDetail.virtuosoVoyage &&
      itinerary.itineraryDetail.virtuosoVoyage.cruiseBenefits &&
      itinerary.itineraryDetail.virtuosoVoyage.cruiseBenefits.length &&
      _.find(
        Object.values(passengers),
        (p) =>
          p.travelerPreferences.selectedVirtuosoCruiseBenefit > 0 &&
          _.find(
            itinerary.itineraryDetail.virtuosoVoyage.cruiseBenefits,
            (b) => b.id === p.travelerPreferences.selectedVirtuosoCruiseBenefit,
          ),
      ),
    [itinerary.itineraryDetail.virtuosoVoyage, passengers],
  );

  return (
    <>
      <StateroomDetails itinerary={itinerary} />
      <InfoBlock title="Cruise details">
        <div className="grid grid-cols-2 text-sm">
          {/* {passengerCity
            && (
              <>
                <div>Resident city (for resident rates):</div>
                <div>{passengerCity}</div>
              </>
            )} */}
          <div>Cruise line:</div>
          <div>{itinerary.itineraryDetail.cruiseLine.cruiseLineName}</div>
          <div>Ship:</div>
          <div>{itinerary.itineraryDetail.ship.shipName}</div>
          <div>Sailing dates:</div>
          <div>
            {dayjs(itinerary.itineraryDetail.itineraryDepartDate).format('MMM D,YYYY')} -{' '}
            {dayjs(itinerary.itineraryDetail.itineraryReturnDate).format('MMM D,YYYY')}
          </div>
          {itinerary.itineraryDetail.itineraryNumNights && (
            <>
              <div>Duration:</div>
              <div>
                <Pluralize singular="night" count={itinerary.itineraryDetail.itineraryNumNights} />
              </div>
            </>
          )}
          <div>Passengers:</div>
          <div>
            {formatStateroomsInput(staterooms, travelAgency && travelAgency.enabledTransportModes)}
          </div>
          {/* <div>
            {travelersCount}
            {' '}
            {isMixedTypeOfPassengers ? 'traveler' : selectedAgeGroups[0]}
            {travelersCount > 1 ? 's' : ''}
          </div> */}
          <div>Ports:</div>
          <div className="inline">
            <PortsOfCall itineraryPortsOfCall={itinerary.itineraryDetail.itineraryPortsOfCall} />
          </div>
        </div>
      </InfoBlock>
      {doHaveVirtuosoBenefits && (
        <InfoBlock title="Virtuoso Voyages Benefits">
          <div className="grid grid-cols-2 text-sm">
            {Object.values(passengers).map(
              (p, index) =>
                p.travelerPreferences.selectedVirtuosoCruiseBenefit > 0 &&
                _.find(
                  itinerary.itineraryDetail.virtuosoVoyage.cruiseBenefits,
                  (b) => b.id === p.travelerPreferences.selectedVirtuosoCruiseBenefit,
                ) && (
                  <Fragment key={p.id}>
                    <div>Passenger {index + 1}:</div>
                    <div className="inline">
                      {
                        _.find(
                          itinerary.itineraryDetail.virtuosoVoyage.cruiseBenefits,
                          (b) => b.id === p.travelerPreferences.selectedVirtuosoCruiseBenefit,
                        ).title
                      }
                    </div>
                  </Fragment>
                ),
            )}
          </div>
        </InfoBlock>
      )}
    </>
  );
};

CruiseInfo.propTypes = {
  itinerary: PropTypes.shape().isRequired,
  // passengerCity: PropTypes.string,
  tripConfirmation: PropTypes.shape({
    travelers: PropTypes.arrayOf(PropTypes.shape({})),
  }),
};

CruiseInfo.defaultProps = {
  // passengerCity: undefined,
  tripConfirmation: undefined,
};

export default memo(CruiseInfo);
